module.exports = __webpack_public_path__ + "static/media/22.e7373c62.png";